import { InputNumber } from 'antd';
import { TFieldRendererProps } from '@/types/TSmartCRM';
import { EFieldMode } from 'src/enums/ESmartCRM';

export const NumberRenderer = ({
	value,
	onChange,
	mode,
	disabled = false,
	placeholder,
}: TFieldRendererProps) => {
	if (mode === EFieldMode.DISPLAY) {
		const displayValue = value !== null && value !== undefined ? String(value) : '-';
		return <span>{displayValue}</span>;
	}

	const numericValue =
		typeof value === 'number'
			? value
			: value !== null && value !== undefined
				? Number(value)
				: undefined;

	return (
		<InputNumber
			value={numericValue}
			onChange={onChange}
			disabled={disabled}
			placeholder={placeholder}
			style={{ width: '100%' }}
		/>
	);
};
